<template>
  <el-dialog
    :title="$t('text.create_organisation')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    :append-to-body="appendToBody"
    @close="closeDialog()"
    width="600px"
    class="edit-group"
  >
    <CreateOrganisation
      ref="createOrganisation"
      @loadingChange="loadingChange"
      @createSuccess="organisationSuccess"
    />
    <div slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="loading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button
        class="cancel-btn min-w-80"
        :disabled="loading"
        @click="closeDialog(true)"
      >
        {{ $t('text.cancel').toUpperCase() }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import swal from 'sweetalert'
import CreateOrganisation from '@/components/register/CreateOrganisation'
import ApiService from '@/services/ApiService.js'
export default {
  props: {
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false
    }
  },
  components: {
    CreateOrganisation
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog(cancelled = false) {
      if (cancelled && this.loading) return
      this.dialogVisible = false
      if (cancelled) this.$emit('cancel')
    },
    loadingChange(val) {
      this.loading = val
    },
    organisationSuccess() {
      this.getOrganisations()
      swal({
        icon: 'success',
        timer: 2000,
        title: this.$t('text.created_successfully')
      })
      this.closeDialog()
      this.$emit('createSuccess')
    },
    getOrganisations() {
      ApiService.GetOrganisations(document.domain)
        .then(response => {
          if (response.data.success) {
            let user = JSON.parse(localStorage.getItem('user'))
            user.organisations = response.data.data.map(organisation => {
              return {
                ...organisation,
                Active:
                  organisation.OrganisationName.OrganisationId ===
                  this.$store.getters[`user/selecteOrganisationId`]
              }
            })
            this.$store.commit('user/SET_USER_DATA', user)
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    submit() {
      this.$refs.createOrganisation.submit()
    }
  }
}
</script>
